// extracted by mini-css-extract-plugin
export default {"control":"control_control__X4eno","button":"control_button__EUkF1"};